import React, { Component }     from 'react';
import PropTypes                from 'prop-types';
import { connect }              from 'react-redux';
import { LinearProgress }       from 'material-ui';
import CloseIcon                from '../CloseIcon';
import {
  styles,
  CONTAINER_HEIGHT,
  ErrorDiv,
  FormWrapperDiv,
  HeaderTitle,
  emailConfirmationStyle,
} from './styles';

import { getErrorDescription }  from './EmailUpdateConfirmationUtil';
import { ACCENT_COLOR }         from '../../config/colors';

import './style.css';

class EmailUpdateConfirmation extends Component {
    state = {
      mainContainerHeight: CONTAINER_HEIGHT,
    }

   renderProgress = () => (
     <div>
       <div>Verifying Email Address</div>
       <LinearProgress color={ACCENT_COLOR} mode="indeterminate" />

     </div>
   )

   render() {
     const {
       errorMessage,
       onCloseRequest,
       isLoading,
       isEmailUpdated,
     } = this.props;

     const { mainContainerHeight } = this.state;

     return (
       <React.Fragment>
         <div
           aria-hidden="true"
           role="button"
           tabIndex={0}
           onClick={onCloseRequest}
           style={styles.closeIconWrap}
         >
           <CloseIcon style={styles.closeIcon} />
         </div>
         <FormWrapperDiv style={{ height: mainContainerHeight }}>
           <div style={emailConfirmationStyle}>
             { isEmailUpdated && <HeaderTitle>Email successfully updated</HeaderTitle> }
             { errorMessage && <ErrorDiv>{getErrorDescription(errorMessage)}</ErrorDiv> }
             <div style={{ height: '30px' }} />
             {isLoading && this.renderProgress()}
             {!isLoading && <div style={{ height: '4px' }} />}
           </div>
         </FormWrapperDiv>
       </React.Fragment>
     );
   }
}

const mapStateToProps = state => ({
  primaryColor: state.config.primaryColor,
  secondaryColor: state.config.secondaryColor,
});

EmailUpdateConfirmation.propTypes = {
  errorMessage: PropTypes.string,
  onCloseRequest: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isEmailUpdated: PropTypes.bool.isRequired,
};

EmailUpdateConfirmation.defaultProps = {
  errorMessage: '',
};

export default connect(mapStateToProps, null)(EmailUpdateConfirmation);



// WEBPACK FOOTER //
// ./src/components/EmailUpdateConfirmationModal/EmailUpdateConfirmation.jsx